interface TelegramOAuthOptions {
  bot_id: string;
  request_access?: boolean;
}

function generateTwitterOAuthUrl(
  baseUrl: string,
  options: Record<string, any>,
) {
  const fullUrl = `${baseUrl}/i/oauth2/authorize`;
  const qs = new URLSearchParams(options).toString();
  return `${fullUrl}?${qs}`;
}

// GOOGLE
const GOOGLE_API_URL = import.meta.env.VITE_REACT_APP_GOOGLE_API_URL!;
const GOOGLE_CLIENT_ID = import.meta.env.VITE_REACT_APP_GOOGLE_CLIENT_ID!;

// TELEGRAM
const TELEGRAM_OAUTH_OPTIONS = {
  bot_id: import.meta.env.VITE_REACT_APP_TELEGRAM_BOT_ID!,
  request_access: true,
};

// TWITTER
const TWITTER_API_URL = import.meta.env.VITE_REACT_APP_TWITTER_API_URL!;

const TWITTER_OAUTH_OPTIONS = {
  redirect_uri: import.meta.env.VITE_REACT_APP_TWITTER_REDIRECT_URI!,
  client_id: import.meta.env.VITE_REACT_APP_TWITTER_CLIENT_ID!,
  state: 'state',
  response_type: 'code',
  code_challenge: 'challenge',
  code_challenge_method: 'plain',
  scope: ['users.read'].join(' '),
};

const TWITTER_OAUTH_URL = generateTwitterOAuthUrl(
  TWITTER_API_URL,
  TWITTER_OAUTH_OPTIONS,
);

export {
  GOOGLE_API_URL,
  GOOGLE_CLIENT_ID,
  TELEGRAM_OAUTH_OPTIONS,
  TWITTER_API_URL,
  TWITTER_OAUTH_URL,
};
export type { TelegramOAuthOptions };
